import React, { useEffect, useState } from 'react';
import { apiClient } from '../api/api';
import { useNavigate } from 'react-router-dom';

const formatTimestamp = (ts) => {
  if (!ts) return '-';
  const d = new Date(ts * 1000);
  return d.toLocaleString();
};

const PromotionStatus = () => {
  const [promotions, setPromotions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPromotions = async () => {
      setLoading(true);
      setError('');
      try {
        const res = await apiClient.get('/promotions', {credentials: 'include', withCredentials: true});
        let promos = res.data.activities || [];
        setPromotions(promos);
      } catch (err) {
        // Log the full error object for debugging
        // eslint-disable-next-line no-console
        console.error('Error fetching promotions:', err, err?.response);
        setError(err.response?.data?.detail || err.message || 'Failed to fetch promotions');
      } finally {
        setLoading(false);
      }
    };
    fetchPromotions();
  }, []);

  useEffect(() => {

  }, []);

  return (
    <div style={{ padding: 0, minHeight: '100vh', background: 'linear-gradient(120deg, #f8fafc 0%, #e0f7fa 100%)', borderRadius: 18 }}>
      <div style={{
        maxWidth: '100%',
        // margin: '0 auto',
        background: 'rgba(255,255,255,0.95)',
        borderRadius: 8,
        boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.10)',
        padding: '32px 28px',
        position: 'relative',
        overflow: 'hidden',
      }}>
        <h1 style={{
          fontSize: 32,
          fontWeight: 800,
          marginBottom: 32,
          letterSpacing: '-1px',
          background: 'linear-gradient(90deg, #0a2540 0%, #010101 40%, #fe2c55 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
        }}>
          Promotion Status
        </h1>
        {loading && <div style={{ fontSize: 18, color: '#000000', fontWeight: 600, marginBottom: 18 }}>Loading promotions...</div>}
  {/* Error display removed as per request */}
        <div style={{ overflowX: 'auto', borderRadius: 12, boxShadow: '0 2px 8px #e0e7ef' }}>
          <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0, background: 'white', borderRadius: 12, minWidth: 900 }}>
            <thead>
              <tr style={{ background: 'linear-gradient(90deg, #25f4ee 0%, #e0f7fa 100%)', fontWeight: 700, color: '#222' }}>
                <th style={{ padding: 16, borderBottom: '2px solid #e0e7ef', fontSize: 15, letterSpacing: '0.02em' }}>Title</th>
                <th style={{ padding: 16, borderBottom: '2px solid #e0e7ef', fontSize: 15 }}>Status</th>
                <th style={{ padding: 16, borderBottom: '2px solid #e0e7ef', fontSize: 15 }}>Type</th>
                <th style={{ padding: 16, borderBottom: '2px solid #e0e7ef', fontSize: 15 }}>Discount Type</th>
                <th style={{ padding: 16, borderBottom: '2px solid #e0e7ef', fontSize: 15 }}>Start</th>
                <th style={{ padding: 16, borderBottom: '2px solid #e0e7ef', fontSize: 15 }}>End</th>
                <th style={{ padding: 16, borderBottom: '2px solid #e0e7ef', fontSize: 15 }}>Target Areas</th>
                <th style={{ padding: 16, borderBottom: '2px solid #e0e7ef', fontSize: 15 }}>Details</th>
              </tr>
            </thead>
            <tbody>
              {promotions.length === 0 && !loading && !error && (
                <tr>
                  <td colSpan={8} style={{ textAlign: 'center', padding: 32, color: '#888', fontSize: 18, fontWeight: 500 }}>
                    <span role="img" aria-label="no-promos" style={{ fontSize: 32, marginRight: 8 }}>🕵️‍♂️</span>
                    No promotions found.
                  </td>
                </tr>
              )}
              {promotions.map((promo) => {
                const area = promo.discount?.shipping_discount?.area_scope?.specific_areas || '-';
                let discountType = '-';
                if (promo.discount?.bmsm_discount) discountType = 'PERCENTAGE_OFF';
                else if (promo.discount?.gift_discount) discountType = 'GIFT';
                else if (promo.discount?.shipping_discount) discountType = 'FREE_SHIPPING';
                else if (promo.activity_type) discountType = promo.activity_type;
                return (
                  <tr key={promo.id} style={{ borderBottom: '1px solid #f1f1f1', transition: 'background 0.2s' }}
                    onMouseEnter={e => e.currentTarget.style.background = '#f0faff'}
                    onMouseLeave={e => e.currentTarget.style.background = 'white'}
                  >
                    <td style={{ padding: 14, fontWeight: 600 }}>{promo.title}</td>
                    <td style={{ padding: 14 }}>
                      <span style={{
                        padding: '4px 12px',
                        borderRadius: 8,
                        background: promo.status === 'ONGOING' ? '#e0f7fa' : promo.status === 'SCHEDULED' ? '#fffbe6' : '#fbeaea',
                        color: promo.status === 'ONGOING' ? '#0097a7' : promo.status === 'SCHEDULED' ? '#bfa100' : '#c62828',
                        fontWeight: 700,
                        fontSize: 14
                      }}>{promo.status}</span>
                    </td>
                    <td style={{ padding: 14 }}>{promo.activity_type}</td>
                    <td style={{ padding: 14 }}>{discountType}</td>
                    <td style={{ padding: 14 }}>{formatTimestamp(promo.begin_time)}</td>
                    <td style={{ padding: 14 }}>{formatTimestamp(promo.end_time)}</td>
                    <td style={{ padding: 14 }}>{area}</td>
                    <td style={{ padding: 14 }}>
                      <button onClick={() => navigate(`/backend-metrics/promotions/${promo.id}`)}
                        style={{
                          padding: '7px 18px',
                          borderRadius: 8,
                          background: 'linear-gradient(90deg, #25f4ee 0%, #fe2c55 100%)',
                          color: '#fff',
                          border: 'none',
                          fontWeight: 700,
                          fontSize: 15,
                          cursor: 'pointer',
                          boxShadow: '0 2px 8px #e0e7ef',
                          transition: 'background 0.2s, box-shadow 0.2s',
                        }}
                      >View</button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PromotionStatus;
